
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/item-list/[id]/[slug]",
      function () {
        return require("private-next-pages/item-list/[id]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/item-list/[id]/[slug]"])
      });
    }
  